import { render, staticRenderFns } from "./DefineAoiStep.vue?vue&type=template&id=63c89318&scoped=true"
import script from "./DefineAoiStep.vue?vue&type=script&lang=js"
export * from "./DefineAoiStep.vue?vue&type=script&lang=js"
import style0 from "./DefineAoiStep.vue?vue&type=style&index=0&id=63c89318&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63c89318",
  null
  
)

export default component.exports